<app-admin-list-page [title]="'Field of interest' | translate">

  <button slot="actions" class="btn btn-primary" (click)="addAreaOfInterest()">
    {{'Add' | translate}}
  </button>

  <app-table [config]="configTable" (buttonEvent)="handleButtonEvent($event)"></app-table>

</app-admin-list-page>
